var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=tcrc%252F%25E6%259C%2588%25E5%25BA%25A6%25E7%25BB%259F%25E8%25AE%25A1%25E8%25A1%25A8.cpt&ref_t=design&op=view&ref_c=ec8baa04-dbe2-4fd7-954d-f51db568aaef","id":"mobsf","width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }